module.exports = __webpack_public_path__ + "img/shoplogo.fba7e454.svg";